const channelDictES = {
  channelHeaderNote: "Tiendas seleccionadas para ScontiPoste",
  channelCart: "Carrito",
  channelTicketTitle: "{percent}% de cashback ScontiPoste",
  channelTicketRule:
    "Paga con tu tarjeta Postepay o BancoPosta: Poste Italiane abona el cashback, normalmente en 5 días.",
  channelTicketWarning:
    "Con otras tarjetas la compra es válida, pero Poste Italiane no reconoce el cashback.",
  channelSearchPlaceholder: "Busca un producto",
  channelSearch: "Buscar",
  channelAllCategories: "Todo",
  channelNoProducts: "Todavía no hay productos aquí. Prueba otra categoría u otra búsqueda.",
  channelLoadMore: "Mostrar más productos",
  channelFreeDelivery: "Envío gratis",
  channelPickup: "Recogida en tienda",
  channelSoldBy: "Vendido por {seller}",
  channelAddToCart: "Añadir al carrito",
  channelAdded: "Añadido al carrito",
  channelGoToCart: "Ir al carrito",
  channelQuantity: "Cantidad",
  channelChooseOption: "Elige {name}",
  channelChooseVariation: "Elige una opción",
  channelOutOfStock: "Agotado",
  channelPickupAt: "Recogida en: {address}",
  channelPickupDays: "Tienes {days} días para recogerlo.",
  channelBackToShop: "Volver a los productos",
  channelDescription: "Descripción",
  channelCartTitle: "Tu carrito",
  channelCartEmpty: "Tu carrito está vacío.",
  channelCartEmptyAction: "Ver productos",
  channelShippedBy: "Enviado por {seller}",
  channelPickupFrom: "Recogida en {seller}",
  channelRemove: "Quitar",
  channelDecrease: "Reducir cantidad",
  channelIncrease: "Aumentar cantidad",
  channelShipping: "Envío",
  channelShippingFree: "Gratis",
  channelTotal: "Total",
  channelPricesIncludeFees: "Los precios incluyen los gastos de servicio.",
  channelCheckoutCta: "Continuar con la compra",
  channelUnavailableItem: "Este producto ya no está disponible: quítalo para continuar.",
  channelCheckoutTitle: "Completa tu compra",
  channelYourDetails: "Tus datos",
  channelFirstname: "Nombre",
  channelSurname: "Apellido",
  channelEmail: "Email",
  channelEmailHelp: "Aquí te enviamos la confirmación del pedido.",
  channelPhone: "Teléfono (opcional)",
  channelDeliveryAddress: "Dirección de entrega",
  channelAddress: "Calle",
  channelNumber: "Número",
  channelPostalCode: "Código postal",
  channelCity: "Ciudad",
  channelProvince: "Provincia (sigla, ej. RM)",
  channelItalyOnly: "Solo entregamos en Italia.",
  channelPickupOnly: "Todos los productos se recogen en tienda: no hace falta una dirección.",
  channelPayment: "Pago",
  channelCardHelp: "Usa tu tarjeta Postepay o BancoPosta para recibir el cashback.",
  channelCardName: "Nombre en la tarjeta",
  channelCardNumber: "Número de la tarjeta",
  channelCardExpiry: "Caducidad",
  channelCardCvv: "CVV",
  channelPay: "Pagar {total}",
  channelFillRequired: "Completa los campos obligatorios.",
  channelInvalidEmail: "Introduce un email válido.",
  channelInvalidCard: "Revisa los datos de la tarjeta.",
  channelPaymentFailed: "El pago no se ha completado. Inténtalo de nuevo o usa otra tarjeta.",
  channelAccountNote: "Con la compra creamos una cuenta Extraconomy gratuita para que sigas tus pedidos.",
  channelOrderSummary: "Resumen",
  channelThanksTitle: "Pedido confirmado",
  channelThanksIntro: "¡Gracias! Hemos recibido el pago de {total}.",
  channelThanksOrders: "Tus pedidos",
  channelOrderNumber: "Pedido n.º {id}",
  channelThanksDelivery: "El vendedor envía el paquete a la dirección que indicaste.",
  channelThanksPickup: "Recoges el producto en la tienda del vendedor.",
  channelThanksNewAccount:
    "Hemos creado tu cuenta Extraconomy con {email}. Abre el email que te enviamos y elige una contraseña para seguir tus pedidos.",
  channelThanksExistingAccount: "El pedido está en tu cuenta Extraconomy ({email}). Inicia sesión para seguirlo.",
  channelLogin: "Iniciar sesión",
  channelThanksCashback:
    "Si pagaste con Postepay o BancoPosta, Poste Italiane abona el {percent}% de cashback, normalmente en 5 días.",
  channelContinueShopping: "Seguir comprando",
  channelThanksMissing: "Los detalles del pedido ya no están en esta página. Los encuentras en el email de confirmación.",
  channelPasswordTitle: "Crea tu contraseña",
  channelPasswordIntro: "Con la contraseña entras en tu cuenta y sigues tus pedidos.",
  channelPassword: "Contraseña",
  channelPasswordConfirm: "Repite la contraseña",
  channelPasswordHelp: "Al menos 8 caracteres.",
  channelPasswordMismatch: "Las contraseñas no coinciden.",
  channelPasswordSave: "Crear contraseña y entrar",
  channelPasswordInvalidLink:
    "El enlace no es válido o ha caducado. Para recibir otro, usa \"Olvidé mi contraseña\" en la página de acceso.",
  channelGoToLogin: "Ir al acceso",
  channelProcessingTitle: "Estamos confirmando el pago",
  channelProcessingText: "Puede tardar unos segundos. No cierres ni recargues esta página.",
  channelInvalidItalianAddress: "Introduce un código postal italiano de 5 cifras y la sigla de la provincia (ej. RM).",
  channelError500438: "Introduce un código postal italiano de 5 cifras y la sigla de la provincia (ej. RM).",
  orderDetailsChannelCashbackBuyer: "Pedido ScontiPoste: el cashback no se abona en Extraconomy. Si pagaste con una tarjeta Postepay o BancoPosta, Poste Italiane lo abona en la tarjeta, normalmente en 5 días.",
  orderDetailsChannelCashbackSeller: "Pedido ScontiPoste: este cashback se descuenta de la venta y Poste Italiane se lo paga al cliente en su tarjeta.",
  channelLoading: "Cargando",
  channelGenericError: "Algo ha fallado. Inténtalo de nuevo en un momento.",
  channelError500037: "Producto no encontrado.",
  channelError500069: "Elige una opción del producto.",
  channelError500074: "Uno de los productos está agotado. Revisa el carrito.",
  channelError500417: "Esta tienda no existe.",
  channelError500418: "Esta tienda no está disponible en este momento.",
  channelError500419: "Uno de los productos ya no está disponible. Revisa el carrito.",
  channelError500420: "Revisa las cantidades del carrito.",
  channelError500423: "Los precios del carrito han cambiado. Revisa el total e inténtalo de nuevo.",
  channelError500424: "La sesión de pago no es válida. Recarga la página e inténtalo de nuevo.",
  channelError500425: "No pudimos confirmar el pago. Si se te cobró, el importe se reembolsa.",
  channelError500426: "Introduce la dirección de entrega.",
  channelError500427: "Solo entregamos en Italia.",
  channelError500428: "Introduce nombre, apellido y un email válido.",
  channelError500429: "No puedes comprar tus propios productos.",
  channelError500430: "No pudimos completar la compra y el pago ha sido reembolsado.",
  channelError500431:
    "El enlace no es válido o ha caducado. Para recibir otro, usa \"Olvidé mi contraseña\" en la página de acceso.",
  channelError500432: "La contraseña debe tener al menos 8 caracteres.",
  channelError500433: "El carrito tiene demasiados productos.",
};

export default channelDictES;
